import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonCard } from './Card.definition';
provideChameleonDesignSystem().register(chameleonCard());
